export default __webpack_public_path__ + "static/media/PhoneFingerprints.3add5129.png";